import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Activities() {
  const activities = [{
    id: 1,
    title: 'Альпінізм',
    subtitle: 'Сходження на вершини',
    description: 'Класичний альпінізм, висотні сходження та технічні маршрути.',
    image: 'https://images.unsplash.com/photo-1454496522488-7a8e488e8606?w=800&q=80',
    link: '/alpinism'
  }, {
    id: 2,
    title: 'Скелелазіння',
    subtitle: 'Олімпійський вид спорту',
    description: 'Боулдеринг, трудність та швидкість на штучному та природному рельєфі.',
    image: 'https://images.unsplash.com/photo-1522163182402-834f871fd851?w=800&q=80',
    link: '/climbing'
  }, {
    id: 4,
    title: 'Скі-альпінізм',
    subtitle: 'Гірські лижі',
    description: 'Поєднання гірських лиж та альпінізму. Швидкісні підйоми та спуски.',
    image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&q=80',
    link: null
  }];
  return <section id="activities" className="py-20 bg-gray-50 border-b border-gray-200" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="text-center mb-12" data-id="element-102">
          <span className="text-primary/50 font-semibold tracking-wider uppercase text-xs" data-id="element-103">
            Напрямки діяльності
          </span>
          <h2 className="mt-2 text-3xl font-heading font-bold text-primary" data-id="element-104">
            Дисципліни Федерації
          </h2>
          <p className="mt-4 text-base text-gray-600 max-w-2xl mx-auto" data-id="element-105">
            Ми розвиваємо різні види гірського спорту, від класичних сходжень до
            сучасних олімпійських дисциплін.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-106">
          {activities.map((activity, index) => {
          const CardContent = <motion.div key={activity.id} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="group relative h-80 rounded-lg overflow-hidden shadow-md bg-gray-900 cursor-pointer" data-id="element-107">
                {/* Background Image */}
                <div className="absolute inset-0 bg-cover bg-center opacity-80 transition-transform duration-700 group-hover:scale-105" style={{
              backgroundImage: `url(${activity.image})`
            }} data-id="element-108" />

                {/* Uniform Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/70 to-primary/30" data-id="element-109" />

                {/* Content */}
                <div className="absolute inset-0 p-8 flex flex-col justify-end text-white" data-id="element-110">
                  <span className="text-xs font-medium text-white/60 uppercase tracking-wider mb-2 block" data-id="element-111">
                    {activity.subtitle}
                  </span>
                  <h3 className="text-2xl font-heading font-bold mb-2 flex items-center" data-id="element-112">
                    {activity.title}
                  </h3>
                  <p className="text-white/80 text-sm leading-relaxed mb-4 max-w-md" data-id="element-113">
                    {activity.description}
                  </p>
                  <div className="flex items-center text-xs font-semibold text-white/90 uppercase tracking-wide group-hover:text-white transition-colors" data-id="element-114">
                    Детальніше{' '}
                    <ArrowRight className="ml-2 h-3 w-3 group-hover:translate-x-1 transition-transform" data-id="element-115" />
                  </div>
                </div>
              </motion.div>;
          return activity.link ? <Link key={activity.id} to={activity.link} className="block" data-id="element-116">
                {CardContent}
              </Link> : <div key={activity.id} data-id="element-117">{CardContent}</div>;
        })}
        </div>
      </div>
    </section>;
}